var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect, useState } from "react";
import "../intersection-observer";
export function useVisible(props) {
    var el = props.el, options = props.options;
    var _a = useState(true), visible = _a[0], setVisible = _a[1];
    useEffect(function () {
        if (!el.current)
            return;
        // 初始化 IntersectionObserver 实例
        var intersectionObserver = new IntersectionObserver(function (entries) {
            setVisible(entries[0].intersectionRatio === 1);
        }, __assign(__assign({}, options), { threshold: [1] }));
        // 开始监听
        intersectionObserver.observe(el.current);
        return function () {
            // 销毁
            intersectionObserver.disconnect();
        };
        // 依赖不可优化，按照 vscode 推荐优化会导致多次渲染
    }, [el.current]);
    return visible;
}
